export default () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.31 19.16">
    <path d="M19.6 2H4.26L4 .58A.72.72 0 0 0 3.31 0H.71a.71.71 0 0 0 0 1.42h2l2 11-.85 1.4a2.68 2.68 0 1 0 2.8 2.67 2.57 2.57 0 0 0-.33-1.26h7.27a2.57 2.57 0 0 0-.33 1.26A2.68 2.68 0 1 0 16 13.8H5.55l.54-.9v-.07l13.68-3.31a.71.71 0 0 0 .54-.69V2.68A.71.71 0 0 0 19.6 2zM4 17.74a1.27 1.27 0 1 1 1.26-1.26A1.27 1.27 0 0 1 4 17.74zm13.24-1.26a1.27 1.27 0 1 1-1.31-1.26H16a1.27 1.27 0 0 1 1.25 1.26zm1.66-8.21L6 11.41l-1.48-8H18.9z" />
  </svg>
);
